export interface CustomAxiosHeaders {
  host?: string
  headers?: any
  serviceName?: string
  useNewToken?: boolean
  skipInterceptor?: boolean
}

let keys: {
  Locations?: string
  CustomObjects?: string
  CustomFields?: string
  Logs?: string
  Users?: string
  Contacts?: string
  Audit?: string
  BladePlatformService?: string
  Opportunities?: string
  Conversations?: string
  Companies?: string
  SocialMediaService?: string
  AffiliateManager?: string
  PerformanceMonitoringService?: string
  CustomEmails?: string
  EmailISV?: string
  Wordpress?: string
  Onboarding?: string
  Launchpad?: string
  Oauth?: string
  Integrations?: string
  Platform?: string
  Business?: string
  Calendar?: string
  Campaigns?: string
  Notification?: string
  Links?: string
  Urls?: string
  Leadconnector?: string
  Hooks?: string
  InternalTools?: string
  AffiliatePortal?: string
  SaaS?: string
  Isv?: string
  SaaSAPI?: string
  SaaSBilling?: string
  SaaSBillingV2?: string
  EmailReporting?: string
  CallsReporting?: string
  ReportingNotification?: string
  GAReporting?: string
  SMSReporting?: string
  OpportunitiesReporting?: string
  Templates?: string
  AppEngine?: string
  Yext?: string
  Sockets?: string
  PhoneSystem?: string
  Reselling?: string
  Documents?: string
  Scoring?: string
  Videos?: string
  ChatWidget?: string
  WebshotService?: string
  AffiliateService?: string
  Wallet?: string
  AdPublishingService?:string
  Prospecting?: string
  ConversationReportingService?: string
  Associations?: string
  VoiceAI?: string
  AiWrapper?: string
  CustomMenuLinks?: string
  Reputation?: string
  DocumentContracts?: string
  CustomData?: string
  SupportBot?: string
  Seo?: string
} = {}

export const override = false

if (
  override ||
  process.env.NODE_ENV === 'production' ||
  process.env.NODE_ENV === 'beta'
) {
  keys = {
    Audit: 'https://backend.leadconnectorhq.com/logs/audit',
    CustomObjects: "https://backend.leadconnectorhq.com/objects",
    CustomFields: "https://backend.leadconnectorhq.com/custom-fields",
    CustomEmails: 'https://backend.leadconnectorhq.com/email-auth',
    Locations: 'https://backend.leadconnectorhq.com/locations',
    Logs: 'https://backend.leadconnectorhq.com/logs',
    Users: 'https://backend.leadconnectorhq.com/users',
    Contacts: 'https://backend.leadconnectorhq.com/contacts',
    Opportunities: 'https://backend.leadconnectorhq.com/opportunities',
    Conversations: 'https://backend.leadconnectorhq.com/conversations',
    Companies: 'https://backend.leadconnectorhq.com/companies',
    SocialMediaService:
      'https://backend.leadconnectorhq.com/social-media-posting',
    Wordpress: 'https://backend.leadconnectorhq.com/wordpress',
    EmailISV: 'https://backend.leadconnectorhq.com/email-isv',
    Platform: 'https://backend.leadconnectorhq.com/platform',
    Onboarding: 'https://backend.leadconnectorhq.com/onboarding',
    Launchpad: 'https://backend.leadconnectorhq.com/launchpad',
    Oauth: 'https://backend.leadconnectorhq.com/oauth',
    Business: 'https://backend.leadconnectorhq.com/businesses',
    Integrations: 'https://backend.leadconnectorhq.com/integrations',
    Calendar: 'https://backend.leadconnectorhq.com/calendars',
    Campaigns: 'https://backend.leadconnectorhq.com/campaigns',
    AffiliateManager: 'https://backend.leadconnectorhq.com/affiliate-manager',
    PerformanceMonitoringService: `https://${window.location.host}/_pm`,
    Notification: 'https://backend.leadconnectorhq.com/notifications',
    Links: 'https://backend.leadconnectorhq.com/links',
    Urls: 'https://backend.leadconnectorhq.com/urls',
    Leadconnector: 'https://backend.leadconnectorhq.com/leadconnector',
    InternalTools: 'https://backend.leadconnectorhq.com/internal-tools',
    AffiliatePortal: 'https://backend.leadconnectorhq.com/affiliate-portal',
    SaaS: 'https://backend.leadconnectorhq.com/saas_service',
    Isv: 'https://backend.leadconnectorhq.com/isv_service',
    SaaSAPI: 'https://backend.leadconnectorhq.com/saas-api',
    SaaSBilling: 'https://backend.leadconnectorhq.com/saas_billing',
    SaaSBillingV2: 'https://backend.leadconnectorhq.com/saas-billing-v2',
    EmailReporting: 'https://backend.leadconnectorhq.com/conversations-reporting/emails',
    CallsReporting: 'https://backend.leadconnectorhq.com/reporting/calls',
    ReportingNotification: 'https://backend.leadconnectorhq.com/reporting/notification',
    GAReporting: 'https://backend.leadconnectorhq.com/reporting/google-analytics',
    SMSReporting: 'https://backend.leadconnectorhq.com/conversations-reporting/messages',
    Templates: 'https://backend.leadconnectorhq.com/templates',
    AppEngine: 'https://backend.leadconnectorhq.com/appengine',
    Yext: 'https://backend.leadconnectorhq.com/yext',
    Sockets: 'https://backend.leadconnectorhq.com',
    PhoneSystem: 'https://backend.leadconnectorhq.com/phone-system',
    Hooks: 'https://backend.leadconnectorhq.com/hooks',
    Reselling: 'https://backend.leadconnectorhq.com/reselling',
    Documents: 'https://backend.leadconnectorhq.com/documents',
    Scoring: 'https://backend.leadconnectorhq.com/scoring',
    Videos: 'https://backend.leadconnectorhq.com/videos',
    ChatWidget: 'https://backend.leadconnectorhq.com/chat-widget',
    WebshotService: 'https://backend.leadconnectorhq.com/webshot-v2',
    AffiliateService: 'https://backend.leadconnectorhq.com/affiliate-portal',
    OpportunitiesReporting:'https://backend.leadconnectorhq.com/reporting/opportunities',
    Wallet: 'https://backend.leadconnectorhq.com/saas_wallet_service',
    AdPublishingService:'https://backend.leadconnectorhq.com/ad-publishing',
    Prospecting: 'https://backend.leadconnectorhq.com/prospecting',
    ConversationReportingService: 'https://backend.leadconnectorhq.com/conversations-reporting',
    Associations: 'https://services.leadconnectorhq.com/associations',
    VoiceAI: 'https://services.leadconnectorhq.com/voice-ai',
    AiWrapper: 'https://services.leadconnectorhq.com/ai-wrapper',
    CustomMenuLinks: 'https://backend.leadconnectorhq.com/custom-menus',
    Reputation: 'https://backend.leadconnectorhq.com/reputation',
    DocumentContracts: 'https://services.leadconnectorhq.com/proposals',
    CustomData:'https://backend.leadconnectorhq.com/custom-data',
     SupportBot: 'https://services.leadconnectorhq.com/support-bot',
     BladePlatformService : 'https://services.leadconnectorhq.com/blade-platform',
     Seo: 'https://services.leadconnectorhq.com/seo'
  }
  if (process.env.NODE_ENV === 'beta') {
    keys.Contacts = 'https://beta.services.msgsndr.com/contacts'
    keys.Opportunities = 'https://beta.services.msgsndr.com/opportunities'
    keys.Conversations = 'https://beta.services.msgsndr.com/conversations'
    keys.Oauth = 'https://beta.services.msgsndr.com/oauth'
    keys.Locations = 'https://beta.services.msgsndr.com/locations'
    keys.Users = 'https://beta.services.msgsndr.com/users'
    keys.Integrations = 'https://beta.services.msgsndr.com/integrations'
    keys.Leadconnector = 'https://backend.leadconnectorhq.com/leadconnector'
    keys.SaaS = 'https://backend.leadconnectorhq.com/saas_service'
    keys.Isv = 'https://backend.leadconnectorhq.com/isv_service'
    keys.SaaSAPI = 'https://backend.leadconnectorhq.com/saas-api'
    keys.SaaSBilling = 'https://backend.leadconnectorhq.com/saas_billing'
    keys.SaaSBillingV2 = 'https://backend.leadconnectorhq.com/saas-billing-v2'
    keys.PhoneSystem = 'https://backend.leadconnectorhq.com/phone-system'
    keys.Scoring = 'https://backend.leadconnectorhq.com/scoring'
    keys.Reselling = 'https://backend.leadconnectorhq.com/reselling'
    keys.ChatWidget = 'https://backend.leadconnectorhq.com/chat-widget'
    keys.OpportunitiesReporting = 'https://backend.leadconnectorhq.com/reporting/opportunities'
    keys.VoiceAI = 'https://beta.services.msgsndr.com/voice-ai',
    keys.AiWrapper= 'https://beta.services.msgsndr.com/ai-wrapper',
    keys.CustomMenuLinks = 'https://backend.leadconnectorhq.com/custom-menus',
    keys.SupportBot =  'https://services.leadconnectorhq.com/support-bot',
    keys.BladePlatformService = 'https://services.leadconnectorhq.com/blade-platform',
    keys.Seo = 'https://services.leadconnectorhq.com/seo'
  }
} else if (
  process.env.NODE_ENV === 'staging' ||
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test'
) {
  keys = {
    Audit: 'https://staging.backend.leadconnectorhq.com/logs/audit',
    BladePlatformService:'https://staging.backend.leadconnectorhq.com/blade-platform',
    CustomObjects: "https://staging.backend.leadconnectorhq.com/objects",
    CustomFields: "https://staging.backend.leadconnectorhq.com/custom-fields",
    CustomEmails: 'https://staging.backend.leadconnectorhq.com/email-auth',
    Locations: 'https://staging.backend.leadconnectorhq.com/locations',
    Logs: 'https://staging.backend.leadconnectorhq.com/logs',
    Users: 'https://staging.backend.leadconnectorhq.com/users',
    Contacts: 'https://staging.backend.leadconnectorhq.com/contacts',
    Opportunities: 'https://staging.backend.leadconnectorhq.com/opportunities',
    Conversations:  'https://staging.backend.leadconnectorhq.com/conversations',
    Companies: 'https://staging.backend.leadconnectorhq.com/companies',
    SocialMediaService:
      'https://staging.backend.leadconnectorhq.com/social-media-posting',
    EmailISV: 'https://staging.backend.leadconnectorhq.com/email-isv',
    Wordpress: 'https://staging.backend.leadconnectorhq.com/wordpress',
    Onboarding: 'https://staging.backend.leadconnectorhq.com/onboarding',
    Launchpad: 'https://staging.backend.leadconnectorhq.com/launchpad',
    Oauth: 'https://staging.backend.leadconnectorhq.com/oauth',
    Business: 'https://staging.backend.leadconnectorhq.com/businesses',
    Integrations: 'https://staging.backend.leadconnectorhq.com/integrations',
    Platform: 'https://staging.backend.leadconnectorhq.com/platform',
    Calendar: 'https://staging.backend.leadconnectorhq.com/calendars',
    Campaigns: 'https://staging.backend.leadconnectorhq.com/campaigns',
    AffiliateManager:
      'https://staging.backend.leadconnectorhq.com/affiliate-manager',
    PerformanceMonitoringService: window.location.host == 'staging.gohighlevel.com'  ? `https://staging.gohighlevel.com/_pm` : `https://staging.backend.leadconnectorhq.com/performance-monitoring`,
    Notification: 'https://staging.backend.leadconnectorhq.com/notifications',
    Links: 'https://staging.backend.leadconnectorhq.com/links',
    Urls: 'https://staging.backend.leadconnectorhq.com/urls',
    Leadconnector: 'https://staging.backend.leadconnectorhq.com/leadconnector',
    InternalTools:
      'https://staging.backend.leadconnectorhq.com/internal-tools',
    AffiliatePortal: 'https://staging.backend.leadconnectorhq.com/affiliate-portal',
    Isv: 'https://staging.backend.leadconnectorhq.com/isv_service',
    SaaS: 'https://staging.backend.leadconnectorhq.com/saas_service',
    SaaSAPI: 'https://staging.backend.leadconnectorhq.com/saas-api',
    SaaSBilling: 'https://staging.backend.leadconnectorhq.com/saas_billing',
    SaaSBillingV2:
      'https://staging.backend.leadconnectorhq.com/saas-billing-v2',
    EmailReporting:
      'https://staging.backend.leadconnectorhq.com/conversations-reporting/emails',
    CallsReporting:
      'https://staging.backend.leadconnectorhq.com/reporting/calls',
    ReportingNotification:
      'https://staging.backend.leadconnectorhq.com/reporting/notification',
    GAReporting: 'https://staging.backend.leadconnectorhq.com/reporting/google-analytics',
    SMSReporting: 'https://staging.backend.leadconnectorhq.com/conversations-reporting/messages',
    Templates: 'https://staging.backend.leadconnectorhq.com/templates',
    AppEngine: 'https://staging.backend.leadconnectorhq.com/appengine',
    Yext: 'https://staging.backend.leadconnectorhq.com/yext',
    Sockets: 'https://staging.backend.leadconnectorhq.com',
    PhoneSystem: 'https://staging.backend.leadconnectorhq.com/phone-system',
    Hooks: 'https://staging.backend.leadconnectorhq.com/hooks',
    Reselling: 'https://staging.backend.leadconnectorhq.com/reselling',
    Documents: 'https://staging.backend.leadconnectorhq.com/documents',
    Scoring: 'https://staging.backend.leadconnectorhq.com/scoring',
    Videos: 'https://staging.backend.leadconnectorhq.com/videos',
    ChatWidget: 'https://staging.backend.leadconnectorhq.com/chat-widget',
    WebshotService: 'https://staging.backend.leadconnectorhq.com/webshot-v2',
    AffiliateService: 'https://staging.backend.leadconnectorhq.com/affiliate-portal',
    OpportunitiesReporting:'https://staging.backend.leadconnectorhq.com/reporting/opportunities',
    Wallet: 'https://staging.backend.leadconnectorhq.com/saas_wallet_service',
    AdPublishingService:'https://staging.backend.leadconnectorhq.com/ad-publishing',
    Prospecting: 'https://staging.backend.leadconnectorhq.com/prospecting',
    ConversationReportingService: 'https://staging.backend.leadconnectorhq.com/conversations-reporting',
    Associations: 'https://staging.backend.leadconnectorhq.com/associations',
    VoiceAI: 'https://staging.backend.leadconnectorhq.com/voice-ai',
    AiWrapper: 'https://staging.backend.leadconnectorhq.com/ai-wrapper',
    CustomMenuLinks: 'https://staging.backend.leadconnectorhq.com/custom-menus',
    Reputation: 'https://staging.backend.leadconnectorhq.com/reputation',
    DocumentContracts: 'https://staging.services.leadconnectorhq.com/proposals',
    CustomData:'https://staging.backend.leadconnectorhq.com/custom-data',
     SupportBot: 'https://staging.services.leadconnectorhq.com/support-bot',
     Seo: 'https://staging.services.leadconnectorhq.com/seo'
  }
  if (process.env.NODE_ENV === 'development') {
    // keys.CustomObjects = "http://localhost:5096/objects"
    // keys.CustomObjects = "http://localhost:5096/objects"
    // keys.CustomFields = "http://localhost:5099/custom-fields"
    // keys.Locations = 'http://localhost:5056/locations'
    // keys.Contacts = 'http://localhost:5058/contacts'
    // keys.Opportunities = 'http://localhost:5066/opportunities'
    //keys.Conversations = 'http://localhost:5063/conversations'
    // keys.Companies = 'http://localhost:5079/companies'
    // keys.CustomEmails = 'http://localhost:5084/email-auth'
    // keys.SocialMediaService = 'http://localhost:7020/social-media-posting'
    // keys.EmailISV = 'http://localhost:5083/email-isv',
    // keys.Onboarding = 'http://localhost:5086/onboarding'
    // keys.Launchpad = 'http://localhost:5187/launchpad'
    // keys.Oauth = 'http://localhost:5062/oauth';
    // keys.Integrations = 'http://localhost:5059/integrations'
    // keys.Calendar: 'http://localhost:5080/calendars',
    // keys.Campaigns: 'http://localhost:5069/campaigns',
    // keys.AffiliateManager = 'http://localhost:5086/affiliate-manager'
    // keys.Notification = 'http://localhost:5082/notifications'
    // keys.Business="http://localhost:5094/businesses"
    // keys.Urls = 'http://localhost:5099/urls'
    // keys.Links= 'http://localhost:5073/links'
    // keys.Leadconnector = 'http://localhost:6050'
    // keys.Users = 'http://localhost:5065/users'
    // keys.InternalTools = 'http://localhost:5103/internal-tools'
    // keys.Logs = 'http://localhost:5075/logs'
    // keys.Documents = 'http://localhost:5303/documents'
    // keys.Scoring = 'http://localhost:5108/scoring'
    // keys.Videos = 'http://localhost:5066/videos'
    //keys.Reputation = 'http://localhot:9611/reputation'
    // keys.DocumentContracts= 'http://localhost:5092/proposals'
    // keys.AiWrapper= 'http://localhost:5114/ai-wrapper'
  }
}
else if (process.env.NODE_ENV === 'interop') {
  keys = {
    Audit: 'https://interop.backend.leadconnectorhq.com/logs/audit',
    BladePlatformService:'https://interop.backend.leadconnectorhq.com/blade-platform',
    CustomObjects: "https://interop.backend.leadconnectorhq.com/objects",
    CustomFields: "https://interop.backend.leadconnectorhq.com/custom-fields",
    CustomEmails: 'https://interop.backend.leadconnectorhq.com/email-auth',
    Locations: 'https://interop.backend.leadconnectorhq.com/locations',
    Logs: 'https://interop.backend.leadconnectorhq.com/logs',
    Users: 'https://interop.backend.leadconnectorhq.com/users',
    Contacts: 'https://interop.backend.leadconnectorhq.com/contacts',
    Opportunities: 'https://interop.backend.leadconnectorhq.com/opportunities',
    Conversations:  'https://interop.backend.leadconnectorhq.com/conversations',
    Companies: 'https://interop.backend.leadconnectorhq.com/companies',
    SocialMediaService:
      'https://interop.backend.leadconnectorhq.com/social-media-posting',
    EmailISV: 'https://interop.backend.leadconnectorhq.com/email-isv',
    Wordpress: 'https://interop.backend.leadconnectorhq.com/wordpress',
    Onboarding: 'https://interop.backend.leadconnectorhq.com/onboarding',
    Launchpad: 'https://interop.backend.leadconnectorhq.com/launchpad',
    Oauth: 'https://interop.backend.leadconnectorhq.com/oauth',
    Business: 'https://interop.backend.leadconnectorhq.com/businesses',
    Integrations: 'https://interop.backend.leadconnectorhq.com/integrations',
    Platform: 'https://interop.backend.leadconnectorhq.com/platform',
    Calendar: 'https://interop.backend.leadconnectorhq.com/calendars',
    Campaigns: 'https://interop.backend.leadconnectorhq.com/campaigns',
    AffiliateManager:
      'https://interop.backend.leadconnectorhq.com/affiliate-manager',
    PerformanceMonitoringService: window.location.host == 'interop.gohighlevel.com'  ? `https://interop.gohighlevel.com/_pm` : `https://interop.backend.leadconnectorhq.com/performance-monitoring`,
    Notification: 'https://interop.backend.leadconnectorhq.com/notifications',
    Links: 'https://interop.backend.leadconnectorhq.com/links',
    Urls: 'https://interop.backend.leadconnectorhq.com/urls',
    Leadconnector: 'https://interop.backend.leadconnectorhq.com/leadconnector',
    InternalTools:
      'https://interop.backend.leadconnectorhq.com/internal-tools',
    AffiliatePortal: 'https://interop.backend.leadconnectorhq.com/affiliate-portal',
    Isv: 'https://interop.backend.leadconnectorhq.com/isv_service',
    SaaS: 'https://interop.backend.leadconnectorhq.com/saas_service',
    SaaSAPI: 'https://interop.backend.leadconnectorhq.com/saas-api',
    SaaSBilling: 'https://interop.backend.leadconnectorhq.com/saas_billing',
    SaaSBillingV2:
      'https://interop.backend.leadconnectorhq.com/saas-billing-v2',
    EmailReporting:
      'https://interop.backend.leadconnectorhq.com/conversations-reporting/emails',
    CallsReporting:
      'https://interop.backend.leadconnectorhq.com/reporting/calls',
    ReportingNotification:
      'https://interop.backend.leadconnectorhq.com/reporting/notification',
    GAReporting: 'https://interop.backend.leadconnectorhq.com/reporting/google-analytics',
    SMSReporting: 'https://interop.backend.leadconnectorhq.com/conversations-reporting/messages',
    Templates: 'https://interop.backend.leadconnectorhq.com/templates',
    AppEngine: 'https://interop.backend.leadconnectorhq.com/appengine',
    Yext: 'https://interop.backend.leadconnectorhq.com/yext',
    Sockets: 'https://interop.backend.leadconnectorhq.com',
    PhoneSystem: 'https://interop.backend.leadconnectorhq.com/phone-system',
    Hooks: 'https://interop.backend.leadconnectorhq.com/hooks',
    Reselling: 'https://interop.backend.leadconnectorhq.com/reselling',
    Documents: 'https://interop.backend.leadconnectorhq.com/documents',
    Scoring: 'https://interop.backend.leadconnectorhq.com/scoring',
    Videos: 'https://interop.backend.leadconnectorhq.com/videos',
    ChatWidget: 'https://interop.backend.leadconnectorhq.com/chat-widget',
    WebshotService: 'https://interop.backend.leadconnectorhq.com/webshot-v2',
    AffiliateService: 'https://interop.backend.leadconnectorhq.com/affiliate-portal',
    OpportunitiesReporting:'https://interop.backend.leadconnectorhq.com/reporting/opportunities',
    Wallet: 'https://interop.backend.leadconnectorhq.com/saas_wallet_service',
    AdPublishingService:'https://interop.backend.leadconnectorhq.com/ad-publishing',
    Prospecting: 'https://interop.backend.leadconnectorhq.com/prospecting',
    ConversationReportingService: 'https://interop.backend.leadconnectorhq.com/conversations-reporting',
    Associations: 'https://interop.backend.leadconnectorhq.com/associations',
    VoiceAI: 'https://interop.backend.leadconnectorhq.com/voice-ai',
    AiWrapper: 'https://interop.backend.leadconnectorhq.com/ai-wrapper',
    CustomMenuLinks: 'https://interop.backend.leadconnectorhq.com/custom-menus',
    Reputation: 'https://interop.backend.leadconnectorhq.com/reputation',
    DocumentContracts: 'https://interop.services.leadconnectorhq.com/proposals',
    CustomData:'https://interop.backend.leadconnectorhq.com/custom-data',
     SupportBot: 'https://interop.services.leadconnectorhq.com/support-bot',
     Seo: 'https://interop.services.leadconnectorhq.com/seo'
  }
}

/**
 * To use a versioned deployment, specify the value in the below versions object.
 *
 * key: className which extends BaseService or serviceName mentioned in service file
 * value: <version_value> : string
 *
 * If this is specified here, it will overwrite the default baseUrl
 * & route the requests to the versioned deployment
 *
 * Versioned deployments will be auto-deleted after 7 days from the date of latest deployment
 *
 */

export const versions = {
  // PlatformService: 'naman28120230',
  // 'CalendarService' : 'anand',
  //'CompanyService' : 'yogi2612',
  // 'ContactService' : 'utkarsh',
  //'ConversationChannelService': 'swapnil',
  //'ConversationsService' : 'gaurav',
  //'IntegrationsServices' : 'gaurav01',
  //'NotificationService' : 'naman27dec',
  // CallsReportingService: 'call-metrics',
  // SMSReportingService: 'agent-reporting-stats',
  // EmailReportingService: 'agent-reporting-stats'
  // WordpressService : 'wp-reselling',
  // OpportunitiesReportingService: '85ztxbkqz-raja'
  // CustomObjectsService:'objects',
  // SocialMediaService: 'mayur'
  // ConversationReportingService: 'email-reporting'
}

export const sandboxTestingBaseUrl =
  'https://staging.backend.leadconnectorhq.com'


export const serviceNameRouteMapping = {
  AuditService: 'logs/audit',
  BusinessService: '',
  CalendarService: 'calendars',
  CompanyService: 'companies',
  ContactService: 'contacts',
  ConversationChannelService: 'conversations',
  ConversationsService: 'conversations',
  CustomEmailsService: '',
  EmailBuilderService: '',
  FormServices: '',
  FunnelServices: '',
  IntegrationsServices: 'integrations',
  LinkService: 'links',
  LocationService: 'locations',
  LocationsService: 'locations',
  LogsService: 'logs',
  NotificationService: 'notifications',
  OauthService: 'oauth',
  OnboardingService: 'onboarding',
  LaunchpadService: 'launchpad',
  OpportunityService: 'opportunity',
  PaymentService: '',
  PlatformService: 'platform',
  ProductService: '',
  SocialMediaService: 'social-media-posting',
  SurveyServices: '',
  Isv: 'isv_service',
  SaaS: 'saas_service',
  TaskService: 'locations',
  UnblockingService: '',
  UsersService: 'users',
  WordpressService: 'wordpress',
  EmailReportingService: 'reporting/emails',
  CallsReportingService: 'reporting/calls',
  SMSReportingService: 'reporting/sms',
  GAReportingService: 'reporting/google-analytics',
  YextService: 'yext',
  OpportunitiesReportingService: 'reporting/opportunities',
  Wallet: 'saas_wallet_service',
  AdPublishingService:'ad-publishing',
  Prospecting: 'prospecting',
  ConversationReportingService: 'conversations-reporting',
  YextResellingService: 'yext',
  Associations: 'association_service',
  VoiceAIService: 'voice_ai',
  AiWrapperService: '',
  CustomMenuLinkService: 'customMenuLinks',
  SupportBot: 'support-bot',
  SeoResellingService: 'seo'
}

export default keys
